import React from 'react';
import classnames from 'classnames';
import { isUndefined } from 'lodash/fp';

import { Calculator, Sort } from '../../shared/icons';
import styles from './SharedAdmin.module.scss';
import { Icon } from '../../shared/icon/Icon';
import { IconButton } from '../../shared/button/IconButton';
import { capitaliseStartLetter } from '../../../utils/regex-utils';
import { ReadOnlyCalculatorField } from '../../datasets/fields/ReadOnlyCalculatorField';
import { DeleteButton } from '../../shared/button/DeleteButton';
import { Button } from '../../shared/button/Button';
import { CalculatorPromptDB } from '../calculator/store';

const { lightGrey, french, grey } = styles;
export const CALCULATOR_FEW_SHOT_LIMIT = 10;

interface CalculatorPromptsProps {
    name: string
    sectionOpen: boolean;
    showReorderIcon: boolean;
    relevantPrompts: CalculatorPromptDB[];
    includeOutput: number;
    includeGracePeriod: number;
    openReorderModal: (promptOrder: CalculatorPromptDB[]) => void;
    duplicatePrompt?: (promptId: number) => void;
    showButtons: (isSystem: boolean) => boolean;
    selectPrompt: (calculatorPromptId?: number | undefined) => void;
    toggleDeleteConfirmationModal: (calculatorPromptId: number | null) => void;
    getSectionOpenIcon: (isOpen: boolean) => React.FC<React.SVGProps<SVGSVGElement>>;
    toggleSection: (calculatorFieldType: string) => void;
}

export const CalculatorPrompts: React.FC<CalculatorPromptsProps> = ({ name, sectionOpen, showReorderIcon, relevantPrompts, includeOutput, includeGracePeriod, openReorderModal, duplicatePrompt, showButtons, selectPrompt, toggleDeleteConfirmationModal, getSectionOpenIcon, toggleSection }) => (
    <div className={styles.calculatorFieldTypeWrapper}>
        <div className={styles.headerWrapper}>
            <div className={styles.calculatorFieldTypeHeader} onClick={() => toggleSection(name)}>
                <div className={styles.sectionOpenIcon}>
                    <Icon icon={getSectionOpenIcon(sectionOpen)} fontSize={15} />
                </div>
                <div className={styles.calculatorFieldTypeTitle}>{capitaliseStartLetter(name)} ( {relevantPrompts.length} )</div>
            </div>
            {showReorderIcon && <div className={styles.reorderButton}><IconButton overlayText='Reorder Prompts' icon={Sort} onClick={() => openReorderModal(relevantPrompts)} fontSize={30} /></div>}
        </div>
        {sectionOpen && relevantPrompts.map(({ calculationText, promptId, priorityOrder, isSystem, ...relevantPrompt }, index) => {
            let priority: number | string = index + 1;
            if (!isUndefined(duplicatePrompt) && isSystem) {
                priority = index > (CALCULATOR_FEW_SHOT_LIMIT - 1) ? '' : index + 1;
            }
            return (
                <div key={index} className={classnames(styles.calculatorPromptExample, { [styles.systemPrompt]: !isUndefined(duplicatePrompt) && isSystem })} style={{ borderColor: index <= (CALCULATOR_FEW_SHOT_LIMIT - 1) ? french : lightGrey }}>
                    <div className={styles.priorityOrder} style={{ color: priorityOrder <= CALCULATOR_FEW_SHOT_LIMIT ? french : grey }}>{priority}</div>
                    <div className={styles.calculationContent}>
                        <div className={styles.calculationText}>
                            {calculationText}
                            {!isUndefined(duplicatePrompt) && isSystem && <Button label='Duplicate' onClick={() => duplicatePrompt(promptId)} />}
                        </div>
                        <div className={styles.calculation}>
                            <div className={styles.readOnlyCalculatorField}>{relevantPrompt.calculation.map(({ calculationCondition, output, gracePeriod, calculation }, calculationIndex) => (
                                <ReadOnlyCalculatorField
                                    value={relevantPrompt.calculation}
                                    calculation={calculation}
                                    output={output}
                                    gracePeriod={gracePeriod}
                                    calculationCondition={calculationCondition}
                                    calculationIndex={calculationIndex}
                                    borderColor={lightGrey}
                                    key={calculationIndex}
                                    showOutputField={includeOutput === 1}
                                    showGracePeriod={includeGracePeriod === 1}
                                />
                            ))}</div>
                        </div>
                        <div className={styles.iconWrapper}>
                            {showButtons(isSystem) && <IconButton icon={Calculator} onClick={() => selectPrompt(promptId)} fontSize={30} />}
                            {showButtons(isSystem) && <DeleteButton onClick={() => toggleDeleteConfirmationModal(promptId)} />}
                        </div>
                    </div>
                </div>
            );
        })}
    </div>
);
